import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LanguageSwitcher from '../../Component/LanguageSwitcher';

const PostOfficeSS = () => {
  const { t } = useTranslation('PostOfficeSS');


  document.title = t('documentTitle');
  document.querySelector('meta[name="description"]').setAttribute('content', t('metaDescription'));

  return (
    <div>
      <header className="d-flex justify-content-end align-items-center p-3 border-bottom">
        <LanguageSwitcher />
      </header>

      <div className="webview">
        <Container>
          <Row>
            <Col xs={12}>
              <Trans
                i18nKey="intro1"
                ns="PostOfficeSS"
                components={[<strong key="0" />]}
              />
              <br />
              <br />
              <Trans
                i18nKey="intro2"
                ns="PostOfficeSS"
                components={[
                  <a
                    key="0"
                    title="Section 80c of Income Tax Act"
                    href="https://www.goodreturns.in/section-80c-of-income-tax-act-s1.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <strong key="1" />,
                  <a
                    key="2"
                    title="PPF Scheme"
                    href="https://www.goodreturns.in/public-provident-fund-sschm2.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                  <a
                    key="3"
                    title="Post Office Saving Schemes that Offer Better Returns than Bank Deposits!"
                    href="https://www.goodreturns.in/personal-finance/3-post-office-schemes-that-offer-better-returns-than-bank-deposits/articlecontent-pf15221-1161659.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                ]}
              />
              <br />
              <br />
              <Trans
                i18nKey="intro3"
                ns="PostOfficeSS"
                components={[
                  <strong key="0" />,
                  <a
                    key="1"
                    title="9 postal saving schemes for savings"
                    href="https://www.goodreturns.in/personal-finance/investment/2018/01/savings-post-office-schemes-662044.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  />,
                ]}
              />

              <h2 className="text-2xl font-bold mb-3">{t('benefitsHeader')}</h2>

              <p className="mb-3">
                <Trans
                  i18nKey="benefitsIntro"
                  ns="PostOfficeSS"
                  components={[<strong key="0" />]}
                />
              </p>

              <ul style={{ listStyleType: "none", paddingLeft: 0, marginLeft: 0 }}>
                <li className="mb-3">
                  <Trans
                    i18nKey="benefitEfficient"
                    ns="PostOfficeSS"
                    components={[<strong key="0" />]}
                  />
                </li>
                <li className="mb-3">
                  <Trans
                    i18nKey="benefitReturns"
                    ns="PostOfficeSS"
                    components={[<strong key="0" />]}
                  />
                </li>
                <li className="mb-3" dangerouslySetInnerHTML={{ __html: t('benefitRateChange') }} />
                <li className="mb-3">
                  <Trans
                    i18nKey="benefitEasyProcess"
                    ns="PostOfficeSS"
                    components={[<strong key="0" />]}
                  />
                </li>
                <li className="mb-3">
                  <Trans
                    i18nKey="benefitLongTerm"
                    ns="PostOfficeSS"
                    components={[<strong key="0" />]}
                  />
                </li>
                <li className="mb-3">
                  <Trans
                    i18nKey="benefitTax"
                    ns="PostOfficeSS"
                    components={[<strong key="0" />]}
                  />
                </li>
                <li className="mb-3">
                  <Trans
                    i18nKey="benefitAccessibility"
                    ns="PostOfficeSS"
                    components={[<strong key="0" />]}
                  />
                </li>
                <li className="mb-3">
                  <Trans
                    i18nKey="benefitOptions"
                    ns="PostOfficeSS"
                    components={[<strong key="0" />]}
                  />
                </li>
              </ul>


              <h2>{t('schemesHeader')}</h2>
              <ul>
                {t('schemesList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('eligibilityHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('eligibility1') }} />

              <h2>{t('applyHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('applyIntro') }} />
              <ul>
                {t('applyList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('typesHeader')}</h2>
              <p dangerouslySetInnerHTML={{ __html: t('typesIntro') }} />

              <h3>{t('savingsAccountHeader')}</h3>
              <ul>
                {t('savingsAccountList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h3>{t('monthlyIncomeHeader')}</h3>
              <p dangerouslySetInnerHTML={{ __html: t('monthlyIncomeIntro') }} />
              <ul>
                {t('monthlyIncomeList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h3>{t('recurringDepositHeader')}</h3>
              <ul>
                {t('recurringDepositList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h3>{t('timeDepositHeader')}</h3>
              <p dangerouslySetInnerHTML={{ __html: t('timeDepositIntro') }} />
              <ul>
                {t('timeDepositList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h3>{t('kisanVikasPatraHeader')}</h3>
              <p dangerouslySetInnerHTML={{ __html: t('kisanVikasPatraIntro') }} />
              <ul>
                {t('kisanVikasPatraList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h3>{t('seniorCitizenHeader')}</h3>
              <ul>
                {t('seniorCitizenList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h3>{t('publicProvidentFundHeader')}</h3>
              <ul>
                {t('publicProvidentFundList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('nationalSavingsCertificateHeader')}</h2>
              <ul>
                {t('nationalSavingsCertificateList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('sukanyaSamriddhiHeader')}</h2>
              <ul>
                {t('sukanyaSamriddhiList', { returnObjects: true })?.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>

              <h2>{t('faqHeader')}</h2>
              <h4>{t('faq1Q')}</h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq1A') }} />
              <h4>{t('faq2Q')}</h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq2A') }} />
              <h4>{t('faq3Q')}</h4>
              <p dangerouslySetInnerHTML={{ __html: t('faq3A') }} />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default PostOfficeSS;